import styled from "styled-components";

export const MyDiv = styled.div`
  .notice-card {
    position: relative;
    background: linear-gradient(
      90deg,
      #ffffff 0%,
      #fff5f5 100%
    ); /* very subtle red tint */
    border-radius: 12px;
    padding: 7px 20px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  }

  .icon {
    color: #dc2626;
    margin-top: 6px;
  }

  .description {
    color: #4b5563;
    line-height: 1.55;
  }

  .highlight {
    font-weight: 600;
    color: #991b1b;
  }

  .progress-label {
    font-size: 12px;
    font-weight: 600;
    color: #7f1d1d;
  }

  .status-text {
    margin-top: 6px;

    color: #991b1b;
    text-align: center;
  }
`;
export default MyDiv;